import React from "react";
import { ArrowLeft, Star, Quote, MapPin, Calendar, ExternalLink, Award, Users } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const Bewertungen = () => {
  const navigate = useNavigate();

  const reviews = [
    {
      name: "Tim Weber",
      location: "Stuttgart",
      rating: 5,
      timeAgo: "vor 11 Monaten",
      service: "Wohnung 60m²",
      text: "Das Team war pünktlich und hat sehr sauber gearbeitet. Alle Möbel und Böden wurden sorgfältig abgedeckt, sodass nichts beschädigt oder verschmutzt wurde. Außerdem haben die Maler mit extremer Präzision gearbeitet, auch an schwierigen Ecken und Kanten. Nach getaner Arbeit wurde alles perfekt aufgeräumt."
    },
    {
      name: "Sandra Schmid", 
      location: "Karlsruhe",
      rating: 5,
      timeAgo: "vor 1 Jahr",
      service: "Renovierung 80m²",
      text: "Sehr zu empfehlen! Ich bin sehr zufrieden, alles hat geklappt wie besprochen. Sehr zuverlässig. Sehr gute Arbeit. Sehr professionell. Sehr freundlich. Das Preis-Leistungs-Verhältnis war auch top."
    },
    {
      name: "Thomas Stickel",
      location: "Mannheim", 
      rating: 5,
      timeAgo: "vor 2 Jahren",
      service: "Mietwohnung 45m²",
      text: "Bevor ich in die neue Mietwohnung eingezogen bin, wollte ich diese selbst streichen, aber da ich mich am Knie verletzt hatte war das nicht möglich. Nun war die Frage, wer kann eine ganze Wohnung innerhalb einer Woche streichen. Ich habe Floria über Google gefunden und kontaktiert. Perfekte Kommunikation und genau im vereinbarten Zeitrahmen war die Wohnung fertig."
    },
    {
      name: "Eugen Usselmann",
      location: "Freiburg",
      rating: 5,
      timeAgo: "vor 4 Jahren",
      service: "Gewerbe-Räume",
      text: "Sehr zu empfehlen. Der Inhaber reagiert schnell auf Anfragen und steht immer beratend zur Verfügung. Das Preis-Leistungs-Verhältnis ist ausgezeichnet und die gelieferte Arbeit ist top. Habe schon mehrere Aufträge vergeben und kann die Firma nur weiterempfehlen. Vielen Dank!"
    },
    {
      name: "Stefan Flöß",
      location: "Heilbronn",
      rating: 5,
      timeAgo: "vor 5 Jahren", 
      service: "Komplette Haussanierung",
      text: "Großartig! Ich habe das ganze Haus renoviert, und alles wurde perfekt gemacht. Der Putz, Trockenbau, Fassade und Sonderwünsche wurden sauber und schnell erledigt. Immer freundlich und zuverlässig. Der Preis war auch sehr fair. Kann ich nur weiterempfehlen!"
    },
    {
      name: "Maria Gonzalez",
      location: "Stuttgart", 
      rating: 5,
      timeAgo: "vor 6 Monaten",
      service: "Airless-Technik 70m²",
      text: "Fantastische Arbeit mit der Airless-Spritztechnik! Das Ergebnis ist absolut professionell und gleichmäßig. Keine Pinselstreifen oder Unebenheiten. Die Wohnung sieht aus wie neu. Sehr empfehlenswert für alle, die Qualität schätzen."
    },
    {
      name: "Michael Wagner",
      location: "Karlsruhe",
      rating: 5,
      timeAgo: "vor 3 Monaten", 
      service: "Express-Service 50m²",
      text: "Unglaublich schnell und trotzdem perfekt! Morgens angerufen, am nächsten Tag war das Team da und bis zum Abend war alles fertig. Saubere Arbeit, faire Preise und sehr freundliche Mitarbeiter. Definitiv mein Maler für die Zukunft!"
    },
    {
      name: "Anna Müller",
      location: "Mannheim",
      rating: 5,
      timeAgo: "vor 8 Monaten",
      service: "Festpreis 40m²", 
      text: "Der Festpreis war genau wie versprochen - keine versteckten Kosten! Die Kommunikation über WhatsApp war super einfach und schnell. Das Ergebnis übertrifft meine Erwartungen. Werde Sie definitiv weiterempfehlen."
    },
    {
      name: "Roberto Italiano",
      location: "Freiburg",
      rating: 5,
      timeAgo: "vor 1 Jahr",
      service: "Wohnung 90m²",
      text: "Perfekte Kommunikation auf Deutsch und Italienisch! Das hat mir sehr geholfen. Die Arbeit ist erstklassig und wurde genau im vereinbarten Zeitrahmen fertiggestellt. Sehr professionell und zuverlässig. Grazie mille!"
    },
    {
      name: "Julia Schneider",
      location: "Heidelberg", 
      rating: 5,
      timeAgo: "vor 4 Monaten",
      service: "PROFITEC Farben 35m²",
      text: "Die Verwendung von hochwertigen PROFITEC Farben macht wirklich einen Unterschied! Die Deckkraft ist excellent und das Finish sieht sehr professionell aus. Top Qualität zu einem fairen Preis."
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`h-4 w-4 ${
          index < rating ? "text-yellow-500 fill-current" : "text-gray-300"
        }`}
      />
    ));
  };

  const averageRating = reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length;
  const totalReviews = reviews.length;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-orange-500 text-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center mb-4">
            <Button
              onClick={() => navigate('/')}
              variant="ghost"
              className="text-white hover:bg-white/20 mr-4"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Zurück zur Startseite
            </Button>
          </div>
          <h1 className="text-3xl lg:text-4xl font-bold">Kundenbewertungen</h1>
          <p className="text-blue-100 text-lg mt-2">Was unsere Kunden über unsere Malerarbeiten sagen</p>
        </div>
      </div>

      {/* Stats Section */}
      <div className="bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <div className="flex justify-center mb-2">
                {renderStars(5)}
              </div>
              <div className="text-3xl font-bold text-gray-900">{averageRating.toFixed(1)}</div>
              <div className="text-sm text-gray-600">Durchschnittsbewertung</div>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <Users className="h-8 w-8 mx-auto mb-2 text-blue-600" />
              <div className="text-3xl font-bold text-gray-900">{totalReviews}</div>
              <div className="text-sm text-gray-600">Zufriedene Kunden</div>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <Award className="h-8 w-8 mx-auto mb-2 text-orange-500" />
              <div className="text-3xl font-bold text-gray-900">100%</div>
              <div className="text-sm text-gray-600">Empfehlungsrate</div>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews Grid */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow">
              
              {/* Review Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-orange-500 rounded-full flex items-center justify-center text-white font-bold">
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{review.name}</h3>
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <MapPin className="h-3 w-3" />
                        <span>{review.location}</span>
                        <span>•</span>
                        <Calendar className="h-3 w-3" />
                        <span>{review.timeAgo}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Service Badge */}
                  <div className="inline-flex items-center gap-1 bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full mb-3">
                    <Award className="h-3 w-3" />
                    {review.service}
                  </div>
                </div>
                
                {/* Rating */}
                <div className="flex items-center gap-1">
                  {renderStars(review.rating)}
                </div>
              </div>

              {/* Review Text */}
              <div className="relative">
                <Quote className="h-8 w-8 text-gray-200 absolute -top-2 -left-1" />
                <p className="text-gray-700 leading-relaxed pl-6 italic">
                  "{review.text}"
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-orange-500 rounded-xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Werden auch Sie unser nächster zufriedener Kunde!</h3>
            <p className="mb-6 text-blue-100">
              Professionelle Malerarbeiten in Baden-Württemberg mit Festpreisen und Zufriedenheitsgarantie
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/4915758183212?text=Hallo,%20ich%20interessiere%20mich%20für%20Ihre%20Malerarbeiten%20und%20möchte%20gerne%20ein%20Angebot."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white text-blue-600 px-6 py-3 rounded-lg hover:bg-gray-100 transition-colors font-medium"
              >
                💬 WhatsApp Kontakt
              </a>
              <Button
                onClick={() => navigate('/')}
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-600 transition-colors"
              >
                🎨 Preiskalkulator nutzen
              </Button>
            </div>
          </div>
        </div>

        {/* Review Invitation */}
        <div className="mt-8 text-center bg-gray-50 rounded-xl p-6">
          <h4 className="font-bold text-gray-900 mb-2">Waren wir auch bei Ihnen tätig?</h4>
          <p className="text-gray-600 mb-4">Teilen Sie Ihre Erfahrung mit anderen Kunden!</p>
          <a
            href="https://wa.me/4915758183212?text=Hallo,%20ich%20möchte%20gerne%20eine%20Bewertung%20für%20Ihre%20Malerarbeiten%20abgeben."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            <Star className="h-4 w-4" />
            Bewertung abgeben
          </a>
        </div>
      </div>
    </div>
  );
};

export default Bewertungen;